import React, { Component } from "react";
import { connect } from "react-redux";

import ChatHeader from "./chat-header";
import ChatContent from "./chat-content";
import ChatIntro from "./chat-intro";
import UserInfo from "../../services/user-info";
import Modal from "../../components/modal/modalChat";
import "./chat.scss";

class Chat extends Component {
  userInfo = UserInfo.getInfo();

  renderContent() {
    return (
      !this.props.app.conversation ?
        <ChatIntro />
        :
        <ChatContent />
    )
  }

  render() {
    const { isRoundedBorderActive } = this.props.config;
    const chatContainerClassName = `chat-container ${this.props.app.minimize ? "omni-hide" : ""
      } ${isRoundedBorderActive ? "roundedBorder" : ""}`;
    // const chatContainerClassName = `chat-container ${isRoundedBorderActive ? "roundedBorder" : ""}`;
    return (
      <div
        className={chatContainerClassName}
      >
        <div>
          <ChatHeader />
          {/* deprecated for now */}
          {/* {this.props.config.isTextToSpeechActive ? (<ChatOptions /> ) : null } */}
          {this.renderContent()}
          <Modal config={this.props.config} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  config: state.config,
});

export default connect(mapStateToProps)(Chat);
